import { LockOutlined } from "@ant-design/icons";
import { Form, Input } from "antd";
import React from "react";

const strongPasswordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

const FormPassword = (props) => {
  // -------------------------- VAR --------------------------
  const { disabled, signup = false } = props;

  // -------------------------- STATE --------------------------
  // -------------------------- FUNCTION -----------------------
  const validatePassword = (_, value) => {
    if (!signup) return Promise.resolve();

    if (!value) {
      return Promise.reject("Vui lòng nhập mật khẩu!");
    }
    if (!strongPasswordRegex.test(value)) {
      return Promise.reject(
        "Mật khẩu phải có ít nhất 8 ký tự, 1 chữ hoa, 1 chữ thường, 1 số và 1 ký tự đặc biệt!",
      );
    }
    return Promise.resolve();
  };
  // -------------------------- MAIN --------------------------
  return (
    <Form.Item
      name="password"
      rules={[
        {
          whitespace: true,
          message: "Không xác định",
        },
        { validator: validatePassword },
      ]}
    >
      <Input.Password
        prefix={<LockOutlined className="form-item-icon" />}
        placeholder="Password"
        type="password"
        disabled={disabled}
        className="min-h-[40px] bg-transparent"
      />
    </Form.Item>
  );
};

export default FormPassword;
